import { MultiSectionDigitalClock } from '@mui/x-date-pickers'
import moment from 'moment'
import { useState } from 'react'

import { formatDate } from '../../helpers'
import { PopoverMenu } from './popover'
import { TextInput } from './textInput'

export const TimeComp = ({
  clicked,
  date,
  minTime,
  referenceDate,
  setDate = () => {},
  className = '',
  disablePast = false,
  disableFuture = false,
}: {
  clicked?: boolean
  date?: Date | null
  minTime?: moment.Moment
  referenceDate?: moment.Moment
  setDate?: (date: moment.Moment | null) => void
  className?: string
  disablePast?: boolean
  disableFuture?: boolean
}) => {
  return (
    <div className={className}>
      <MultiSectionDigitalClock
        value={clicked && date === null ? null : moment(date)}
        onChange={(newDate) => {
          setDate(newDate)
          // close();
        }}
        ampm
        minTime={minTime}
        referenceDate={referenceDate}
        disablePast={disablePast}
        disableFuture={disableFuture}
        className="hide-scroll-bar !border-0 !border-b-0"
        timeSteps={{
          minutes: 1,
        }}
        sx={{
          '& .MuiList-root': {
            border: 'none !important',
          },
          '& .MuiMultiSectionDigitalClockSection-root': {
            border: 'none !important',
            scrollbarWidth: 'none !important',
            display: 'flex',
            flexDirection: 'column',
            gap: '0px',
            ':hover': {
              border: 'none !important',
              scrollbarWidth: 'none !important',
            },
          },
          '& .MuiMultiSectionDigitalClockSection-item': {
            fontFamily: 'Outfit !important',
            fontSize: '12px !important',
            fontWeight: 500,
            color: '#04000A',
            borderRadius: '400px',
            aspectRatio: '1',
            width: '40px',
            height: '40px',
            minWidth: '40px',
            minHeight: '40px',
            maxWidth: '40px',
            maxHeight: '40px',
            //   border: "1px solid",
            margin: '0px',
            backgroundColor: 'trasparennt',
            ':hover': {
              backgroundColor: 'transparent',
            },
          },
          '& .MuiMultiSectionDigitalClockSection-item.Mui-selected': {
            fontWeight: '700 !important',
            backgroundColor: '#04000A',
            color: 'white',
            ':hover': {
              backgroundColor: '#04000A',
              color: 'white',
            },
          },
        }}
      />
    </div>
  )
}

export const TimeInput = ({
  placeholder = '',
  errors = '',
  title = '',
  date,
  minTime,
  referenceDate,
  setDate = () => {},
  onBlur = () => {},
  className = '',
  name,
  disablePast = false,
  disableFuture = false,
  dateDisplayFormat = 'hh:mm A',
  diasbled,
}: {
  placeholder: string
  name: string
  errors?: string
  title?: string
  date?: Date | null
  minTime?: moment.Moment
  referenceDate?: moment.Moment
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
  setDate?: (date: moment.Moment | null) => void
  className?: string
  disablePast?: boolean
  disableFuture?: boolean
  dateDisplayFormat?: string
  diasbled?: boolean
}) => {
  const [clicked, setClicked] = useState<boolean>(false)

  return (
    <PopoverMenu
      customMenuItems={({ close }) => {
        return (
          <TimeComp
            clicked={clicked}
            date={date}
            minTime={minTime}
            referenceDate={referenceDate}
            setDate={setDate}
            className={className}
            disablePast={disablePast}
            disableFuture={disableFuture}
          />
        )
      }}
      menuClassName="rounded-xl bg-white !shadow-lg border z-[999] pl-4"
      className={`w-full`}
      position="bottom"
      diasbled={diasbled}
    >
      <button className="h-fit w-full text-left" type="button">
        <TextInput
          type="text"
          name={name}
          value={formatDate(date, dateDisplayFormat)}
          placeholder={placeholder}
          onChange={() => {}}
          onBlur={(e) => {
            setClicked(true)
            onBlur(e)
          }}
          title={title}
          errors={errors}
          containerClassName=""
          readOnly
          inputClass="!cursor-pointer"
          hasIcon={false}
        />
      </button>
    </PopoverMenu>
  )
}
